export const environment = {
  production: true,
  apiUrl: 'https://ermsurvey-api.adient.com/',
  clientId: 'd2092c93-a0f3-43b8-8111-090688f529f2',
  redirectUri: 'https://ermsurvey.adient.com',
  postLogoutRedirectUri: 'https://connect.adient.com/'

};
